@switch (ansicht()) {
  @case ('laeuft') {
    <app-ki-laeuft [aktion]="'ki.qualitaet.laeuft' | translate" />
  }
  @case ('ergebnis') {
    <div class="ki-qualitaet__ergebnis">
      <div class="ki-qualitaet__kopf">
        <app-ki-badge [label]="'ki.qualitaet.badge' | translate" />
        <span class="ki-qualitaet__anzahl" data-testid="ki-qualitaet-anzahl" aria-live="polite">
          @switch (befunde()?.length ?? 0) {
            @case (0) {
              {{ 'ki.qualitaet.keineBefunde' | translate }}
            }
            @case (1) {
              {{ 'ki.qualitaet.befund' | translate }}
            }
            @default {
              {{ 'ki.qualitaet.befunde' | translate: { anzahl: befunde()?.length } }}
            }
          }
        </span>
        <button
          type="button"
          class="ki-qualitaet__schliessen"
          data-testid="ki-qualitaet-schliessen"
          (click)="schliessen()"
        >
          {{ 'ki.panel.schliessen' | translate }}
        </button>
      </div>
      @for (befund of befunde(); track befund.key) {
        <div
          class="ki-qualitaet__befund"
          data-testid="ki-befund"
          [class.ki-qualitaet__befund--erledigt]="befund.stand !== 'offen'"
        >
          <span
            class="ki-qualitaet__schwere"
            data-testid="ki-befund-schwere"
            [class]="'ki-qualitaet__schwere--' + befund.schwere.toLowerCase()"
          >
            {{ 'ki.qualitaet.schwere.' + befund.schwere | translate }}
          </span>
          <!-- Das ::after des Knopfs deckt die ganze Zeile ab (page-ki.jsx:390); die Aktionen liegen darüber. -->
          <button
            type="button"
            class="ki-qualitaet__befund-inhalt"
            data-testid="ki-befund-zeigen"
            (click)="zeigen(befund)"
          >
            <span class="ki-qualitaet__befund-text" data-testid="ki-befund-text">
              <strong>
                {{
                  befund.schrittNr === null
                    ? ('ki.qualitaet.vorbedingung' | translate)
                    : ('ki.qualitaet.schritt' | translate: { nr: befund.schrittNr })
                }}
              </strong>
              · {{ befund.text }}
            </span>
            @if (befund.vorschlag) {
              <span class="ki-qualitaet__vorschlag" data-testid="ki-befund-vorschlag">
                {{ 'ki.qualitaet.vorschlag' | translate: { text: befund.vorschlag } }}
              </span>
            }
          </button>
          @switch (befund.stand) {
            @case ('offen') {
              @if (!readOnly()) {
                <span class="ki-qualitaet__aktionen">
                  @if (kannVerbessern(befund)) {
                    <button
                      mat-stroked-button
                      type="button"
                      class="ki-qualitaet__aktion"
                      data-testid="ki-verbessern"
                      (click)="verbessernKlick(befund)"
                    >
                      {{ 'ki.qualitaet.verbessern' | translate }}
                    </button>
                  }
                  <button
                    mat-stroked-button
                    type="button"
                    class="ki-qualitaet__aktion"
                    data-testid="ki-lassen"
                    (click)="lassen(befund)"
                  >
                    {{ 'ki.qualitaet.lassen' | translate }}
                  </button>
                </span>
              }
            }
            @case ('verbessert') {
              <span class="ki-qualitaet__stand ki-qualitaet__stand--verbessert" data-testid="ki-befund-stand">
                {{ 'ki.qualitaet.verbessert' | translate }}
              </span>
            }
            @default {
              <span class="ki-qualitaet__stand" data-testid="ki-befund-stand">
                {{ 'ki.qualitaet.gelassen' | translate }}
              </span>
            }
          }
        </div>
      }
      @if (gesendet(); as gesendet) {
        <app-ki-gesendet class="ki-qualitaet__gesendet" [gesendet]="gesendet" />
      }
    </div>
  }
  @default {
    <div class="ki-qualitaet__leiste" data-testid="ki-qualitaet-leiste">
      <app-ki-mark [size]="22" />
      <span class="ki-qualitaet__leiste-text">
        <span class="ki-qualitaet__leiste-titel">{{ 'ki.qualitaet.titel' | translate }}</span>
        <span class="ki-qualitaet__leiste-untertitel">{{ 'ki.qualitaet.untertitel' | translate }}</span>
      </span>
      <app-ki-button
        funktion="TESTDESIGN"
        [label]="'ki.qualitaet.pruefen' | translate"
        [state]="buttonZustand().state"
        [sperrgrund]="buttonZustand().sperrgrund"
        (ausloesen)="pruefen()"
      />
    </div>
    @if (abgelaufen()) {
      <app-ki-ergebnis-abgelaufen class="ki-qualitaet__fehler" />
    }
    @if (fehlerKey(); as fehlerKey) {
      <app-ki-fehler class="ki-qualitaet__fehler" [text]="fehlerKey | translate" (erneut)="pruefen()" />
    }
  }
}

@if (run.hinweis(); as verbindung) {
  <app-ki-erste-nutzung
    [verbindung]="verbindung"
    (verstanden)="run.hinweisVerstanden()"
    (abgebrochen)="run.hinweisAbgebrochen()"
  />
}
